import { withStyles } from '@material-ui/core';

import Select from './component';
import styles from './styles';

export default withStyles(styles)(Select);
